import { Component } from '@angular/core';

import { BillingCycle, BillingInfo } from '../../billing/billing';
import { BillingService } from '../../billing/billing.service';
import { BaseModal } from '../../modals/modal-base';
import {UserService} from '../../user/user.service';

export class BillingDialogArgs {
}

@Component({
    selector: 'dialog-billing',
    templateUrl: './billing-dialog.component.html',
    styleUrls: [
        '../../../../node_modules/bootstrap/dist/css/bootstrap.css',
        './billing-dialog.component.scss'
    ]
})
export class BillingDialog extends BaseModal<BillingDialogArgs> {

    private args: BillingDialogArgs;

    dialogError: string;
    loading: boolean;

    cycles: BillingCycle[];
    currentCycle: BillingCycle;
    userEmail: string;

    constructor(
        private service: BillingService,
        private userService: UserService
    ) {
        super();
        this.cycles = [];
        this.userEmail = this.userService.getCurrentUser().Email;
    }

    onActivate(args: BillingDialogArgs) {
        this.updateCycles();
    }

    onCloseClicked(e: MouseEvent) {
        e.preventDefault();
        this.closeDialog();
    }

    onClose() {
    }

    private updateCycles() {
        this.dialogError = undefined;
        this.loading = true;
        this.service.getCycles().catch(e => {
            this.dialogError = JSON.stringify(e);
            throw e;
        }).subscribe((cycles: BillingInfo) => {
            this.cycles = cycles.cycles;
            this.currentCycle = this.cycles && this.cycles[0];
            this.loading = false;
        });
    }

    downloadInvoice(event: any) {
        if(this.currentCycle.invoiceUrl){
            window.open(this.currentCycle.invoiceUrl);
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/modals/billing/billing-dialog.component.ts